// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.keplr",
    name: "Keplr",
    homepage: "https://keplr.app",
    image_id: "527324b0-3849-462b-9a1a-72b53bdfea00",
    app: {
        browser: "https://wallet.keplr.app",
        ios: "https://apps.apple.com/us/app/keplr-wallet/id1567851089",
        android: "https://play.google.com/store/apps/details?id=com.chainapsis.keplr&hl=en&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap?hl=en",
        firefox: "https://addons.mozilla.org/en-US/firefox/addon/keplr/",
        safari: null,
        edge: "https://microsoftedge.microsoft.com/addons/detail/keplr/ocodgmmffbkkeecmadcijjhkmeohinei",
        opera: null,
    },
    rdns: "app.keplr",
    mobile: {
        native: "keplrwallet://wcV2",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map